module.exports = __webpack_public_path__ + "img/1.3ba26e38.jpg";